/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { UsageType, FindUsageTypeParams } from 'types';

const find = async (params: ?FindUsageTypeParams): Promise<UsageType[]> => {
  const { broadcastTypeId, productionTypeId } = params || {};

  let pathUrl = (broadcastTypeId || 2) + '/' + (productionTypeId || 3);
  const response = await callApiEndpoint(
    'tipologieutilizzo/' + pathUrl + '/findByTipologiaEmissioneAndTipologiaProduzione',
    { params: {} }
  );
  return response.map(utils.toUsageType);
};

export default {
  find,
};
